function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { HeaderBackButton } from "@react-navigation/elements";
import { useNavigation, useRoute } from "@react-navigation/native";
import * as Contacts from "expo-contacts";
import { produce } from "immer";
import groupBy from "lodash/groupBy";
import sortBy from "lodash/sortBy";
import { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { SafeAreaView, SectionList, TouchableHighlight, TouchableOpacity } from "react-native";
import { Button } from "../components/Button";
import { Checkbox } from "../components/Checkbox";
import { Text } from "../components/Text";
import { TextInput } from "../components/TextInput";
import { View } from "../components/View";
import { useI18n } from "../lib/i18n";
import { askAsync } from "../lib/permissionsManager";
import { useTheme } from "../styles";
var ContactsSectionList = SectionList;
var CONTACT_FIELDS = [
    Contacts.Fields.ID,
    Contacts.Fields.ContactType,
    Contacts.Fields.Name,
    Contacts.Fields.FirstName,
    Contacts.Fields.MiddleName,
    Contacts.Fields.LastName,
    Contacts.Fields.MaidenName,
    Contacts.Fields.NamePrefix,
    Contacts.Fields.NameSuffix,
    Contacts.Fields.Nickname,
    Contacts.Fields.PhoneticFirstName,
    Contacts.Fields.PhoneticMiddleName,
    Contacts.Fields.PhoneticLastName,
    Contacts.Fields.Emails,
    Contacts.Fields.PhoneNumbers,
    Contacts.Fields.Addresses,
    Contacts.Fields.Company,
    Contacts.Fields.JobTitle,
    Contacts.Fields.Department,
    Contacts.Fields.ImageAvailable,
    Contacts.Fields.Image,
    Contacts.Fields.RawImage,
    Contacts.Fields.ExtraNames,
    Contacts.Fields.Relationships
];
var ITEM_HEIGHT = 60;
var SectionListItem = /*#__PURE__*/ memo(function SectionListItem(param) {
    var sortCharacter = param.sortCharacter, checked = param.checked, id = param.id, name = param.name, onPress = param.onPress;
    var theme = useTheme().theme;
    var onPressWithId = function() {
        return onPress(id);
    };
    var nameParts = (name !== null && name !== void 0 ? name : '').split(' ').map(function(part, i) {
        var _part_;
        var _part_slice;
        return i > 0 && ((_part_ = part[0]) === null || _part_ === void 0 ? void 0 : _part_.toUpperCase()) === sortCharacter ? [
            part[0],
            "".concat((_part_slice = part.slice(1)) !== null && _part_slice !== void 0 ? _part_slice : '', " ")
        ] : "".concat(part, " ");
    }).flat();
    return /*#__PURE__*/ _jsx(TouchableHighlight, {
        onPress: onPressWithId,
        underlayColor: theme.color.accent100,
        style: [
            {
                padding: 15,
                height: ITEM_HEIGHT
            },
            checked ? {
                backgroundColor: theme.color.accent100
            } : null
        ],
        children: /*#__PURE__*/ _jsxs(View, {
            row: true,
            spacing: 8,
            children: [
                /*#__PURE__*/ _jsx(Checkbox, {
                    onChangeValue: onPressWithId,
                    value: checked,
                    testID: "ContactsPicker_Item_".concat(name)
                }),
                /*#__PURE__*/ _jsx(_Fragment, {
                    children: nameParts.map(function(part, i) {
                        var matchesSortCharacter = (part === null || part === void 0 ? void 0 : part.toUpperCase()) === sortCharacter;
                        return /*#__PURE__*/ _jsx(Text, {
                            text: part,
                            weight: matchesSortCharacter ? 'semibold' : undefined
                        }, i);
                    })
                })
            ]
        })
    });
});
/**
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-178}
 */ export function ContactsPicker(props) {
    var _route_params;
    var theme = useTheme().theme;
    var navigation = useNavigation();
    var route = useRoute();
    var list = useRef(null);
    var _useState = _sliced_to_array(useState(''), 2), filter = _useState[0], setFilter = _useState[1];
    var _useState1 = _sliced_to_array(useState({}), 2), checked = _useState1[0], setChecked = _useState1[1];
    var _useState2 = _sliced_to_array(useState([]), 2), items = _useState2[0], setItems = _useState2[1];
    var navigate = navigation.navigate;
    var returnRoute = (_route_params = route.params) === null || _route_params === void 0 ? void 0 : _route_params.returnRoute;
    var onChooseContacts = props.onChooseContacts;
    var onChooseContactsRef = useRef(onChooseContacts);
    onChooseContactsRef.current = onChooseContacts;
    var onChoose = useCallback(function(contacts, permissionDenied) {
        if (onChooseContactsRef.current) {
            onChooseContactsRef.current({
                contacts: contacts,
                permissionDenied: permissionDenied
            });
        } else {
            navigate({
                name: returnRoute,
                params: {
                    _contactPickerResult: {
                        contacts: contacts,
                        permissionDenied: permissionDenied
                    }
                },
                merge: true
            });
        }
    }, [
        navigate,
        returnRoute
    ]);
    var onChooseRef = useRef(onChoose);
    onChooseRef.current = onChoose;
    var $t = useI18n().$t;
    var setOptions = navigation.setOptions;
    useEffect(function() {
        setOptions({
            title: 'Contacts',
            headerLeft: function(param) {
                var tintColor = param.tintColor;
                return /*#__PURE__*/ _jsx(HeaderBackButton, {
                    onPress: function() {
                        onChoose([]);
                    },
                    tintColor: tintColor
                });
            },
            headerRight: undefined
        });
    }, [
        setOptions,
        onChoose
    ]);
    useEffect(function() {
        void askAsync('Contacts', function() {
            return Contacts.requestPermissionsAsync();
        }, {
            retryIfDenied: true
        }).then(function(param) {
            var status = param.status;
            if (status === 'granted') {
                return Contacts.getContactsAsync({
                    fields: CONTACT_FIELDS
                }).then(function(param) {
                    var data = param.data;
                    setItems(sortBy(data, [
                        'lastName',
                        'name'
                    ]));
                });
            }
            onChooseRef.current([], true);
            return;
        });
    }, []);
    var contactsByInitial = useMemo(function() {
        var getFirstCharGroup = function getFirstCharGroup(str) {
            var first = str[0].toUpperCase();
            return first.match(/[A-Z]/) ? first : '#';
        };
        var lowercaseFilter = filter.toLowerCase();
        var filtered = filter ? items.filter(function(contact) {
            return "".concat(contact.name).concat(contact.lastName).concat(contact.firstName).concat(contact.nickname).toLowerCase().indexOf(lowercaseFilter) >= 0;
        }) : items;
        return groupBy(filtered, function(item) {
            var name = item.lastName || item.name || item.firstName || item.nickname || item.middleName || 'No name';
            var fallbackName = item.name || item.firstName || item.nickname || item.middleName || 'No name';
            var nameChar = getFirstCharGroup(name);
            if (nameChar === '#') return getFirstCharGroup(fallbackName);
            return nameChar;
        });
    }, [
        items,
        filter
    ]);
    var sidebarInitials = useMemo(function() {
        return Object.keys(contactsByInitial).sort();
    }, [
        contactsByInitial
    ]);
    var data = useMemo(function() {
        return Object.entries(contactsByInitial).map(function(param) {
            var _param = _sliced_to_array(param, 2), initial = _param[0], contacts = _param[1];
            return {
                title: initial,
                data: contacts
            };
        }).sort(function(a, b) {
            return a.title < b.title ? -1 : 1;
        });
    }, [
        contactsByInitial
    ]);
    var onToggle = useCallback(function(itemID) {
        setChecked(produce(function(draft) {
            if (draft[itemID]) {
                delete draft[itemID];
            } else {
                draft[itemID] = true;
            }
        }));
    }, []);
    return /*#__PURE__*/ _jsxs(SafeAreaView, {
        style: {
            flex: 1
        },
        children: [
            /*#__PURE__*/ _jsx(TextInput, {
                value: filter,
                onChangeValue: setFilter,
                placeholder: $t({
                    id: 'ContactsPicker_searchPlaceholder',
                    defaultMessage: 'Search'
                }),
                variant: "flat"
            }),
            /*#__PURE__*/ _jsxs(View, {
                flex: 1,
                spacing: 12,
                children: [
                    /*#__PURE__*/ _jsxs(View, {
                        flex: 1,
                        row: true,
                        style: {
                            alignItems: 'stretch'
                        },
                        children: [
                            /*#__PURE__*/ _jsx(ContactsSectionList, {
                                ref: list,
                                getItemLayout: function(_, index) {
                                    return {
                                        length: ITEM_HEIGHT,
                                        offset: ITEM_HEIGHT * index,
                                        index: index
                                    };
                                },
                                renderItem: function(param) {
                                    var section = param.section, item = param.item, index = param.index;
                                    return /*#__PURE__*/ _jsx(SectionListItem, {
                                        sortCharacter: section.title,
                                        onPress: onToggle,
                                        id: item.id || index.toString(),
                                        checked: !!checked[(item === null || item === void 0 ? void 0 : item.id) || index],
                                        name: item.name
                                    });
                                },
                                ItemSeparatorComponent: function() {
                                    return /*#__PURE__*/ _jsx(View, {
                                        style: {
                                            backgroundColor: '#eee',
                                            height: 1
                                        }
                                    });
                                },
                                renderSectionFooter: function() {
                                    return /*#__PURE__*/ _jsx(View, {
                                        style: {
                                            height: 15
                                        }
                                    });
                                },
                                renderSectionHeader: function(param) {
                                    var title = param.section.title;
                                    return /*#__PURE__*/ _jsx(View, {
                                        style: {
                                            padding: 15
                                        },
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            text: title,
                                            weight: "semibold",
                                            size: 15,
                                            style: {
                                                lineHeight: 22
                                            },
                                            color: theme.color.gray300
                                        })
                                    });
                                },
                                sections: data,
                                keyExtractor: function(item, index) {
                                    var _item_id;
                                    var _item_id_toString;
                                    return (_item_id_toString = (_item_id = item.id) === null || _item_id === void 0 ? void 0 : _item_id.toString()) !== null && _item_id_toString !== void 0 ? _item_id_toString : index.toString();
                                },
                                style: [
                                    {
                                        flex: 1
                                    }
                                ]
                            }),
                            /*#__PURE__*/ _jsx(View, {
                                style: {
                                    justifyContent: 'center',
                                    width: 25,
                                    top: 80,
                                    bottom: 0,
                                    position: 'absolute',
                                    right: 8
                                },
                                children: sidebarInitials.map(function(initial, i) {
                                    return /*#__PURE__*/ _jsx(TouchableOpacity, {
                                        onPress: function() {
                                            if (list.current) {
                                                list.current.scrollToLocation({
                                                    itemIndex: 0,
                                                    sectionIndex: i
                                                });
                                            }
                                        },
                                        style: {
                                            paddingHorizontal: 4,
                                            alignItems: 'center'
                                        },
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            text: initial,
                                            size: 15,
                                            style: {
                                                lineHeight: 22
                                            },
                                            color: theme.color.gray300
                                        })
                                    }, initial);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        testID: "ContactsPicker_Choose",
                        text: $t({
                            id: 'ContactsPicker_chooseButton',
                            defaultMessage: 'Add {numContacts, plural, one{1 contact} other{# contacts}}'
                        }, {
                            numContacts: Object.values(checked).filter(function(val) {
                                return !!val;
                            }).length
                        }),
                        onPress: function() {
                            onChoose(items.filter(function(contact, index) {
                                var _contact_id;
                                return !!checked[(_contact_id = contact.id) !== null && _contact_id !== void 0 ? _contact_id : index];
                            }));
                        },
                        alignSelf: "center",
                        disabled: Object.keys(checked).length === 0
                    })
                ]
            })
        ]
    });
}
